import * as React from 'react';
import { DispatchWithoutAction, FC } from 'react';
import { useTheme } from '../../../theme';
import { useTranslation } from 'react-i18next';
import { InsuranceProgramFragment } from '@websky/graphql';
import { default as BaseButton } from '../../../BaseComponents/Button';
import ModalConfirm from '../../../ModalConfirm';
import { UpsaleService } from '@widgets/upsale';
import { FooterMobile, MobileDialog } from '@shared/ui';
import MediaQuery from '../../../MediaQuery/MediaQuery';

interface Props {
	isOpen: boolean;
	insurance?: InsuranceProgramFragment;
	onAgree: DispatchWithoutAction;
	onDisagree: DispatchWithoutAction;
	isLoading?: boolean;
}

export const InsuranceUpsaleModal: FC<Props> = ({ insurance, onAgree, onDisagree, isOpen, isLoading }) => {
	const { InsuranceUpsaleModal: theme } = useTheme('InsurancePage');
	const { t } = useTranslation('InsurancePage');

	const tryTranslateWithProductKey = (
		insuranceProgram: InsuranceProgramFragment,
		key: string,
		defaultValue?: string
	) => {
		return defaultValue
			? t([`${insuranceProgram?.code}_${key}`, key], { defaultValue: defaultValue })
			: t([`${insuranceProgram?.code}_${key}`, key]);
	};

	return (
		<>
			<MediaQuery minWidth={'mobile'}>
				<ModalConfirm
					isOpen={isOpen}
					size={'large'}
					onClose={onDisagree}
					classes={{
						content: theme.content
					}}
					footer={
						<div className={theme.footer}>
							<BaseButton variant="secondary" disabled={isLoading} onClick={onDisagree}>
								{tryTranslateWithProductKey(insurance, 'I assume all risks and Cancel insurance')}
							</BaseButton>

							<BaseButton variant="action" isLoading={isLoading} onClick={onAgree}>
								{tryTranslateWithProductKey(insurance, 'Buy insurance')}
							</BaseButton>
						</div>
					}
				>
					<UpsaleService className={theme.upsaleItem} service={insurance} preselectedService={insurance} />
				</ModalConfirm>
			</MediaQuery>

			<MediaQuery maxWidth={'mobile'}>
				<MobileDialog
					title={tryTranslateWithProductKey(
						insurance,
						'You lose protection and peace of mind in unforeseen situations.'
					)}
					isOpen={isOpen}
					onClose={onDisagree}
					footer={
						<FooterMobile
							onBack={onDisagree}
							onContinue={onAgree}
							backButtonText={tryTranslateWithProductKey(
								insurance,
								'I assume all risks and Cancel insurance'
							)}
							continueButtonText={tryTranslateWithProductKey(insurance, 'Buy insurance')}
						/>
					}
				>
					<UpsaleService className={theme.upsaleItem} service={insurance} preselectedService={insurance} />
				</MobileDialog>
			</MediaQuery>
		</>
	);
};
